module.exports = __webpack_public_path__ + "static/car_crash1-e1a21048b37b364b3fd0a5cba5465650.webp";